/* ============================================================
   EI RECETTE CAPTURE — 2026-08-04
   - Repositionne le bloc de capture après les ingrédients
   - Ingrédients cochables (classe au runtime, HTML source intact)
   - Barre collante mobile (seuil de scroll + mémorisation)
   - Écran de confirmation au retour ?ei_lead=ok
   - Tracking GA4 (dataLayer)

   ⚠️ Ne modifie JAMAIS le contenu texte de l'article.
   Le repositionnement déplace un bloc AJOUTÉ par le thème ;
   le HTML de l'article, lui, n'est ni lu ni réécrit.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-ei-recette-capture]');
  if (!root) return;

  var LS_LEAD = 'ei_lead_ok';
  var LS_STICKY = 'ei_cap_sticky_dismiss';
  var J_LEAD = 180;
  var J_STICKY = 30;

  /* ---------- utilitaires ---------- */

  /* Paramètres de la convention maison EI, déjà transmis par la balise
     « GA4 - EI Nav refonte Events » et déjà déclarés en dimensions GA4.
     En les réutilisant, ce bloc ne demande AUCUNE création côté GTM. */
  var EI_PARAMS = ['ei_source', 'ei_action', 'ei_product', 'ei_query',
                   'ei_result_type', 'ei_rayon', 'ei_position', 'ei_alternative'];

  /* Les appels restent lisibles en français ; la traduction se fait ici,
     à la frontière, pour ne pas éparpiller les noms techniques. */
  var CORRESPONDANCE = {
    bloc: 'ei_source',              /* teaser | main | margot | sticky   */
    action: 'ei_action',            /* ajout | fiche | fiche_confirmation */
    etape: 'ei_action',             /* decoche | envoi_bloque             */
    destination: 'ei_action',       /* bloc_produits                      */
    produit: 'ei_product',
    consent_marketing: 'ei_result_type',
    nb_produits: 'ei_position'
  };

  function ga4(eventName, params) {
    window.dataLayer = window.dataLayer || [];

    var payload = { event: eventName, ei_version: 'v1' };

    /* ⚠️ Reset obligatoire : sans lui, les valeurs d'un événement fuitent
       sur le suivant (constaté chez EI le 02-08-2026). */
    for (var i = 0; i < EI_PARAMS.length; i++) payload[EI_PARAMS[i]] = undefined;

    payload.ei_query = root.getAttribute('data-article-handle') || undefined;
    payload.ei_rayon = root.getAttribute('data-terroir') || undefined;

    var p = params || {};
    for (var k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
      var cle = CORRESPONDANCE[k] || k;
      var v = p[k];
      if (typeof v === 'boolean') v = v ? 'oui' : 'non';
      payload[cle] = v;
    }

    window.dataLayer.push(payload);
  }

  function memSet(cle, jours) {
    try {
      localStorage.setItem(cle, JSON.stringify({
        t: Date.now(),
        exp: Date.now() + jours * 864e5
      }));
    } catch (e) { /* navigation privée : on ignore */ }
  }

  function memActif(cle) {
    try {
      var v = JSON.parse(localStorage.getItem(cle) || 'null');
      if (!v || !v.exp) return false;
      if (Date.now() > v.exp) { localStorage.removeItem(cle); return false; }
      return true;
    } catch (e) { return false; }
  }

  function scrollVers(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  /* ---------- 1. Repositionnement après les ingrédients ---------- */

  function repositionner() {
    /* Le teaser remonte en tête de contenu */
    var teaser = document.querySelector('[data-ei-cap-teaser]');
    var contenu = document.querySelector('.content-post-default.ei-recette');
    if (teaser && contenu && contenu.firstChild) {
      contenu.insertBefore(teaser, contenu.firstChild);
    }

    /* Bloc à repositionner : le bloc navy quand il existe. S'il a été retiré
       (metafield entrepot.capture_mode = "remise"), c'est le bloc Margot qui
       porte l'inscription : c'est donc lui qu'on remonte. */
    var bloc = document.getElementById('ei-cap-main')
            || document.querySelector('[data-ei-cap-block="margot"]');
    if (!bloc) return;

    /* Repère explicite posé dans le corps de l'article : <div data-ei-cap-ici></div>.
       Le bloc vient EXACTEMENT là. Prioritaire sur l'ancre ingrédients, qui
       n'existe que sur les articles écrits avec les classes recipe-content__*
       — les articles d'un autre format n'ont aucun moyen de placer le bloc
       ailleurs qu'en bas de page. Absent : rien ne change. */
    var repere = document.querySelector('[data-ei-cap-ici]');
    if (repere && repere.parentNode) {
      repere.parentNode.insertBefore(bloc, repere);
      bloc.setAttribute('data-ei-repositionne', '1');
      return;
    }

    /* Ancre : le conteneur ingrédients du body_html existant.
       Si absent (article recette d'un autre format), le bloc reste
       où le thème l'a rendu — il ne disparaît jamais. */
    var ancre = ancreIngredients();
    if (!ancre || !ancre.parentNode) return;

    ancre.parentNode.insertBefore(bloc, ancre.nextSibling);
    bloc.setAttribute('data-ei-repositionne', '1');
  }

  /* Le conteneur des ingrédients du body_html. N'existe que sur les
     articles écrits avec les classes recipe-content__* ; ailleurs on
     renvoie null et rien ne bouge. */
  function ancreIngredients() {
    var ancre = document.querySelector('.recipe-content__ingredients');
    if (ancre) return ancre;
    var liste = document.querySelector('.recipe-content__ingredients-list');
    return liste ? liste.parentNode : null;
  }

  /* ---------- 1 sexies. Repli de l'introduction ----------
     Mesuré le 19-08 sur la focaccia, en mobile 375 px : 1 065 px séparent le
     haut de page de la liste d'ingrédients, dont 312 px de prose. Le bloc
     produits, qui suit les ingrédients, tombe donc à 2,3 écrans. Replier
     l'introduction lui rend ~175 px.

     ⚠️ Le texte n'est JAMAIS retiré du DOM : il est seulement borné en
     hauteur (max-height + overflow). Google le lit intégralement, et le
     corps de l'article n'est pas touché. Sans JS, l'introduction s'affiche
     en entier comme avant — jamais de disparition. */

  function replierIntroduction() {
    if (root.getAttribute('data-intro-repli') !== '1') return;

    var ancre = ancreIngredients();
    if (!ancre || !ancre.parentNode) return;

    /* On ne replie que le bloc de prose : le dernier frère `introduction`
       avant les ingrédients qui a une vraie hauteur. Les autres sont soit le
       titre, soit des résidus vides déjà masqués en CSS. Seuil à 150 px pour
       ne jamais replier un titre (96 px sur la focaccia). */
    var prose = null;
    var n = ancre.previousElementSibling;
    while (n) {
      if (n.className && String(n.className).indexOf('recipe-content__introduction') > -1
          && n.getBoundingClientRect().height > 150) { prose = n; break; }
      n = n.previousElementSibling;
    }
    if (!prose || prose.hasAttribute('data-ei-intro')) return;

    var hauteur = parseInt(root.getAttribute('data-intro-hauteur'), 10);
    if (isNaN(hauteur) || hauteur < 0) hauteur = 88;

    var labelOuvrir = root.getAttribute('data-intro-label') || 'Lire l’introduction';
    var labelFermer = root.getAttribute('data-intro-label-ferme') || 'Replier';

    prose.setAttribute('data-ei-intro', '1');
    prose.classList.add('ei-intro-repli');
    prose.style.setProperty('--ei-intro-h', hauteur + 'px');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ei-intro-toggle';
    btn.setAttribute('data-ei-intro-toggle', '');
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = labelOuvrir;

    /* Lien accessible : le bouton commande explicitement la zone de texte. */
    if (!prose.id) prose.id = 'ei-intro-texte';
    btn.setAttribute('aria-controls', prose.id);

    prose.parentNode.insertBefore(btn, prose.nextSibling);

    var ouvert = false;
    btn.addEventListener('click', function () {
      ouvert = !ouvert;
      prose.classList.toggle('ei-ouvert', ouvert);
      btn.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      btn.textContent = ouvert ? labelFermer : labelOuvrir;
      if (ouvert) ga4('ei_recette_intro_deplie', { bloc: 'intro' });
    });
  }

  /* ---------- 1 quinquies. Le bloc produits sous les ingrédients ----------
     Il était rendu en fin de contenu : sur la focaccia, à 4 142 px du haut
     d'une page de 8 605, soit près de six écrans de pouce après la question
     « qu'est-ce qui me manque ? ». Il remonte là où cette question se pose.

     Appelé APRÈS repositionner() : le bloc email vient d'être inséré juste
     après les ingrédients, et on se place devant lui. Ordre obtenu :
     ingrédients → produits → email.

     Sans JS, ou si l'ancre n'existe pas, le bloc reste exactement où le
     thème l'a rendu : le comportement d'avant, jamais une disparition. */

  function remonterBlocProduits() {
    var bloc = document.getElementById('ei-cap-shop');
    if (!bloc) return;

    /* Repli 2026-08-20 : les articles recette d'une autre génération n'ont pas
       les classes recipe-content__*. Ils posent alors un repère explicite
       <div data-ei-cap-ici></div> dans leur corps, juste après les ingrédients.
       Sans repère NI classes, on ne touche à rien : le bloc reste où le thème
       l'a rendu, il ne disparaît jamais. */
    var ancre = ancreIngredients() || document.querySelector('[data-ei-cap-ici]');
    if (!ancre || !ancre.parentNode) return;

    ancre.parentNode.insertBefore(bloc, ancre.nextSibling);
    bloc.setAttribute('data-ei-repositionne', '1');

    /* Le visuel « ESSAYEZ CETTE SÉLECTION ↓ » est un panneau indicateur :
       sa flèche désigne ce qui le suit. Laissé en bas pendant que le bloc
       remonte, il finirait par désigner le bloc email — il mentirait. Il
       remonte donc avec, juste au-dessus. */
    var visuel = document.querySelector('.ei-recette img.ei-conseils-margot')
              || document.querySelector('.ei-recette img[src*="conseils-de-margot"]');
    if (!visuel) return;

    /* Garde-fou : closest() peut remonter jusqu'à un conteneur qui porte
       tout l'article. On ne déplace que si le porteur est bien le petit
       bloc de l'image — sinon on déplace le visuel seul, et en dernier
       recours on ne touche à rien. */
    var porteur = visuel.closest('p, div');
    var enveloppeTrop = !porteur
      || porteur === bloc
      || porteur.contains(bloc)
      || porteur.contains(ancre)
      || porteur.querySelectorAll('img').length > 1
      || (porteur.textContent || '').trim().length > 0;

    var aDeplacer = enveloppeTrop ? visuel : porteur;
    if (aDeplacer && aDeplacer.parentNode && !aDeplacer.contains(bloc)) {
      bloc.parentNode.insertBefore(aDeplacer, bloc);
    }
  }

  /* ---------- 1 ter bis. Le 2e bloc produits, à l'étape de la garniture ----
     Le bloc variante est rendu sous le bloc principal. Sa vraie place est plus
     bas, à l'étape de la recette qui utilise ces produits : c'est le même
     principe que le bloc principal sous la liste d'ingrédients — l'impulsion
     au moment où la question se pose.

     Le rang de l'étape vient du réglage de section, surchargeable par article
     (data-shop2-etape). 0, absent, ou étape inexistante : le bloc RESTE où le
     thème l'a rendu. Jamais de disparition, jamais de place devinée.

     ⚠️ Le panneau « ESSAYEZ CETTE SÉLECTION ↓ » n'est pas touché ici : sa
     flèche doit continuer à désigner le bloc principal, et lui seul. */

  function placerBlocVariante() {
    var bloc = document.getElementById('ei-cap-shop-2');
    if (!bloc) return;

    var rang = parseInt(root.getAttribute('data-shop2-etape'), 10);
    if (!rang || rang < 1) return;

    var etapes = document.querySelectorAll('.recipe-content__preparation-item');
    if (etapes.length < rang) return;   /* recette plus courte que le réglage */

    var apres = etapes[rang - 1];
    if (!apres || !apres.parentNode || apres.contains(bloc)) return;

    /* 🚨 La numérotation des étapes vient d'un compteur CSS : `counter-reset`
       sur la liste, `counter-increment` sur chaque étape. Scinder la liste en
       deux remettrait donc l'étape suivante à « 1 » — régression visible sur
       la page la plus lue du site. On garde UNE seule liste et on y insère le
       bloc dans son propre <li>, neutralisé côté compteur et décorations par
       la classe ei-cap-shop-li. La numérotation continue toute seule. */
    var hote = document.createElement('li');
    hote.className = 'ei-cap-shop-li';
    hote.appendChild(bloc);
    apres.parentNode.insertBefore(hote, apres.nextSibling);

    bloc.setAttribute('data-ei-repositionne', '1');
  }

  /* ---------- 1 quater. Visuel "Les conseils de Margot" ----------
     L'ancien visuel est daté et n'a aucun texte alternatif. On échange
     la source au chargement et on ajoute l'alt manquant : le HTML de
     l'article n'est pas touché, et le remplacement vaut pour TOUTES les
     recettes qui portent cet ancien visuel. */

  function remplacerVisuelConseils() {
    var nouvelle = root.getAttribute('data-conseils-img');
    if (!nouvelle) return;

    var alt = root.getAttribute('data-conseils-alt') || '';
    var cibles = document.querySelectorAll('.ei-recette img[src*="conseils-de-margot"]');

    Array.prototype.forEach.call(cibles, function (img) {
      img.setAttribute('src', nouvelle);
      img.removeAttribute('srcset');
      img.removeAttribute('width');
      img.removeAttribute('height');
      if (alt && !img.getAttribute('alt')) img.setAttribute('alt', alt);
      img.classList.add('ei-conseils-margot');
    });
  }

  /* ---------- 1 ter. Mot de fin "Partagez-nous" ----------
     Ce paragraphe se trouve au milieu de l'article et coupe l'enchaînement
     vers le bloc produits. On le DÉPLACE tout en bas (le HTML source ne
     change pas) et on y ajoute le lien Instagram à côté de Facebook. */

  function deplacerBlocSocial() {
    var conteneur = document.querySelector('.content-post-default.ei-recette');
    if (!conteneur) return;

    var lienFb = conteneur.querySelector('a[href*="facebook.com/lentrepotitalien"]');
    if (!lienFb) return;

    var p = lienFb.closest('p');
    if (!p) return;

    var urlInsta = root.getAttribute('data-instagram-url');
    var labelInsta = root.getAttribute('data-instagram-label') || 'page Instagram';

    if (urlInsta && !p.querySelector('a[href*="instagram.com"]')) {
      var a = document.createElement('a');
      a.href = urlInsta;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.textContent = labelInsta;

      var frag = document.createDocumentFragment();
      frag.appendChild(document.createTextNode(' ou notre '));
      frag.appendChild(a);
      lienFb.parentNode.insertBefore(frag, lienFb.nextSibling);
    }

    p.classList.add('ei-social-fin');
    conteneur.appendChild(p);
  }

  /* ---------- 1 bis. Blocs vides résiduels ----------
     Certains paragraphes de l'article ne contiennent qu'une espace
     insécable : impossible à cibler en CSS, et ils laissent des trous
     blancs. On les masque (style d'affichage seulement, le contenu
     de l'article n'est pas modifié) — et uniquement s'ils ne portent
     ni texte, ni image, ni lien. */

  function masquerBlocsVides() {
    var sels = '.recipe-content__introduction-text,' +
               '.recipe-content__introduction-paragraph';
    document.querySelectorAll('.ei-recette ' + sels).forEach(function (el) {
      var texte = (el.textContent || '').replace(/[\s ]/g, '');
      if (texte) return;
      if (el.querySelector('img, a, iframe, video, picture')) return;
      el.style.display = 'none';
    });
  }

  /* ---------- 2. Ingrédients cochables ---------- */

  function ingredientsCochables() {
    var items = document.querySelectorAll('.recipe-content__ingredients-item');
    if (!items.length) return;

    Array.prototype.forEach.call(items, function (li) {
      li.addEventListener('click', function (e) {
        /* On laisse vivre les liens présents dans les ingrédients */
        if (e.target.closest('a')) return;
        li.classList.toggle('ei-checked');
      });
    });

    var liste = document.querySelector('.recipe-content__ingredients-list');
    var hint = root.getAttribute('data-hint-ingredients');
    if (liste && hint && liste.parentNode) {
      var p = document.createElement('p');
      p.className = 'ei-ing-hint';
      p.textContent = hint;
      liste.parentNode.appendChild(p);
    }
  }

  /* ---------- 3. Barre collante mobile ---------- */

  function sticky() {
    var barre = document.querySelector('[data-ei-cap-sticky]');
    if (!barre) return;

    if (barre.getAttribute('data-customer') === '1') return;
    if (memActif(LS_LEAD) || memActif(LS_STICKY)) return;

    var seuil = parseInt(barre.getAttribute('data-seuil'), 10) || 40;
    var vue = false;
    barre.hidden = false;

    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var pct = h > 0 ? (window.pageYOffset / h) * 100 : 0;

      /* On masque la barre quand le bloc principal est déjà à l'écran :
         inutile de demander deux fois la même chose au même moment. */
      var bloc = document.getElementById('ei-cap-main');
      var blocVisible = false;
      if (bloc) {
        var r = bloc.getBoundingClientRect();
        blocVisible = r.top < window.innerHeight && r.bottom > 0;
      }

      if (pct >= seuil && !blocVisible) {
        if (!barre.classList.contains('ei-on')) {
          barre.classList.add('ei-on');
          if (!vue) { vue = true; ga4('ei_lead_view', { bloc: 'sticky' }); }
        }
      } else {
        barre.classList.remove('ei-on');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var fermer = barre.querySelector('[data-ei-cap-sticky-close]');
    if (fermer) {
      fermer.addEventListener('click', function () {
        barre.classList.remove('ei-on');
        barre.hidden = true;
        memSet(LS_STICKY, J_STICKY);
        ga4('ei_lead_dismiss', { bloc: 'sticky' });
      });
    }
  }

  /* ---------- 4. Écran de confirmation (retour ?ei_lead=ok) ---------- */

  function confirmation() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('ei_lead') !== 'ok') return;

    var bloc = params.get('b') || 'main';
    var cible = document.querySelector('[data-ei-cap-success="' + bloc + '"]');
    if (!cible) cible = document.querySelector('[data-ei-cap-success]');
    if (!cible) return;

    var conteneur = cible.closest('[data-ei-cap-block]') || cible.parentNode;
    var zone = conteneur.querySelector('[data-ei-cap-formzone]');
    if (zone) zone.style.display = 'none';
    cible.hidden = false;

    memSet(LS_LEAD, J_LEAD);

    var barre = document.querySelector('[data-ei-cap-sticky]');
    if (barre) { barre.classList.remove('ei-on'); barre.hidden = true; }

    var teaser = document.querySelector('[data-ei-cap-teaser]');
    if (teaser) teaser.hidden = true;

    ga4('ei_lead_success', { bloc: bloc });

    scrollVers(cible);

    /* Nettoyage de l'URL : on retire le paramètre sans recharger,
       pour ne pas laisser traîner une URL paramétrée indexable. */
    params.delete('ei_lead');
    params.delete('b');
    params.delete('form_type');
    params.delete('customer_posted');
    var q = params.toString();
    history.replaceState({}, '', window.location.pathname + (q ? '?' + q : ''));
  }

  /* ---------- 4 bis. Verrou de consentement (bloc navy) ----------
     La case est cochée par défaut et reste décochable. Décochée, le
     bouton s'éteint et l'envoi est bloqué.

     Pourquoi bloquer plutôt que laisser passer : l'action Flow
     "Send marketing email" REFUSE les profils non abonnés. Une
     inscription sans accord marketing créerait donc un client qui ne
     recevra jamais sa recette — alors que le bloc lui promet de
     l'envoyer "tout de suite". On préfère un refus explicite à une
     promesse silencieusement cassée.

     L'adresse saisie n'est jamais effacée : la personne recoche, le
     bouton se rallume, elle n'a rien à retaper. */

  function verrouConsentement() {
    var form = document.getElementById('ei-cap-form-main');
    if (!form) return;

    var consent = form.querySelector('[data-ei-cap-consent]');
    var btn = form.querySelector('[data-ei-cap-submit]');
    var msg = form.querySelector('[data-ei-cap-lock]');
    if (!consent || !btn) return;

    var refusTracke = false;

    function rafraichir() {
      var ok = consent.checked;
      btn.classList.toggle('is-locked', !ok);
      btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
      if (ok && msg) msg.hidden = true;
    }

    consent.addEventListener('change', function () {
      rafraichir();
      /* Une seule remontée par page : on mesure l'intention de refus,
         pas le nombre d'allers-retours sur la case. */
      if (!consent.checked && !refusTracke) {
        refusTracke = true;
        ga4('ei_lead_consent_refus', { bloc: 'main', etape: 'decoche' });
      }
    });

    /* Sur 'submit' et non sur le clic : couvre aussi la validation
       au clavier depuis le champ email. */
    form.addEventListener('submit', function (e) {
      if (consent.checked) return;
      e.preventDefault();
      if (msg) msg.hidden = false;
      consent.focus();
      ga4('ei_lead_consent_refus', { bloc: 'main', etape: 'envoi_bloque' });
    });

    rafraichir();
  }

  /* ---------- 5. Tracking des blocs ---------- */

  function tracking() {
    /* Impression des blocs */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var nom = en.target.getAttribute('data-ei-cap-block');
          ga4('ei_lead_view', { bloc: nom });
          obs.unobserve(en.target);
        });
      }, { threshold: 0.5 });

      document.querySelectorAll('[data-ei-cap-block]').forEach(function (el) {
        obs.observe(el);
      });

      /* 🚨 querySelectorAll, pas querySelector : depuis le 20-08 il peut y
         avoir DEUX blocs produits sur la page. Avec querySelector, le bloc
         variante n'émettait aucun ei_recette_produits_view — muet en silence,
         et on aurait cru qu'il ne se voyait pas. Le paramètre `bloc` sépare
         les deux dans GA4 ; sans lui, les vues s'additionnent sans qu'on
         puisse dire laquelle vient d'où. */
      document.querySelectorAll('[data-ei-cap-shop]').forEach(function (shop) {
        var obsShop = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            ga4('ei_recette_produits_view', {
              bloc: shop.getAttribute('data-ei-cap-bloc') || 'principal',
              nb_produits: shop.querySelectorAll('[data-ei-prod-id]').length
            });
            obsShop.unobserve(en.target);
          });
        }, { threshold: 0.4 });
        obsShop.observe(shop);
      });
    }

    /* Début de saisie = mesure de la friction */
    document.querySelectorAll('[data-ei-cap-input]').forEach(function (input) {
      input.addEventListener('focus', function () {
        if (input.getAttribute('data-ei-start')) return;
        input.setAttribute('data-ei-start', '1');
        ga4('ei_lead_start', { bloc: input.getAttribute('data-ei-cap-input') });
      });
    });

    /* Envoi */
    document.querySelectorAll('[data-ei-cap-submit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bloc = btn.getAttribute('data-ei-cap-submit');
        var consent = document.querySelector('[data-ei-cap-consent]');
        /* Case décochée : verrouConsentement() bloque l'envoi. On ne
           compte pas un envoi qui n'a pas lieu — le refus a son propre
           événement (ei_lead_consent_refus). */
        if (bloc === 'main' && consent && !consent.checked) return;
        ga4('ei_lead_submit', {
          bloc: bloc,
          consent_marketing: true
        });
      });
    });

    /* Lien d'ingrédient qui renvoie au bloc produits de la page :
       défilement doux plutôt qu'un saut sec, et on trace le clic. */
    document.querySelectorAll('.ei-recette a[href="#ei-cap-shop"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var cible = document.getElementById('ei-cap-shop');
        if (!cible) return; /* pas de bloc produits : on laisse le navigateur faire */
        e.preventDefault();
        scrollVers(cible);
        ga4('ei_recette_lien_ingredient', { destination: 'bloc_produits' });
      });
    });

    /* Teaser + barre collante : saut vers le bloc principal */
    document.querySelectorAll('[data-ei-cap-jump]').forEach(function (b) {
      b.addEventListener('click', function () {
        ga4('ei_lead_teaser_click', { bloc: b.closest('[data-ei-cap-sticky]') ? 'sticky' : 'teaser' });
        scrollVers(document.getElementById('ei-cap-main'));
        var champ = document.getElementById('ei-cap-email-main');
        if (champ) setTimeout(function () { champ.focus({ preventScroll: true }); }, 450);
      });
    });

    /* Clic produit — l'ajout panier lui-même est déjà tracké par
       ei-cart-popover.js (ei_add_to_cart, renommé le 22-09-2026 — il
       s'appelait ei_cart_add et GTM ne le relayait pas). On n'ajoute ici que la
       source, pour ne pas compter deux fois la même conversion. */
    /* 🚨 Délégation en phase de CAPTURE sur document — surtout PAS un écouteur posé
       sur chaque bouton. `ei-cart-popover.js` pose lui aussi un écouteur `click` en
       capture sur document et y appelle `stopPropagation()` sur tout
       `button[name="add"]` d'un form `/cart/add`, pour neutraliser les handlers
       jQuery historiques du thème. L'événement n'atteint donc JAMAIS le bouton :
       un écouteur posé dessus ne part jamais. C'est ce qui a rendu `action: 'ajout'`
       totalement muet du 19-08 au 22-09 — 0 événement en 34 jours, pendant que le
       bloc était vu 8 076 fois et que les ajouts partaient bel et bien.
       `stopPropagation()` n'affecte pas les écouteurs enregistrés sur le MÊME nœud :
       en capture sur document, on est appelé quel que soit l'ordre de chargement
       des deux scripts. Ne pas « simplifier » en revenant sur les boutons. */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-ei-cap-add]') : null;
      if (b) {
        var porteur = b.closest('[data-ei-cap-bloc]');
        ga4('ei_recette_produit_click', {
          action: 'ajout',
          /* Sans ce paramètre, impossible de dire lequel des deux blocs vend :
             les ajouts arriveraient mélangés et la décision A/B ne serait plus
             mesurable après coup. */
          bloc: porteur ? porteur.getAttribute('data-ei-cap-bloc') : 'principal',
          produit: b.getAttribute('data-ei-prod-nom'),
          prix: parseFloat(b.getAttribute('data-ei-prod-prix')) || 0
        });
      }
    }, true);

    /* « Tout ajouter » — événement distinct, et surtout PAS data-ei-cap-add :
       ce bouton ne porte aucun nom de produit, il remonterait un ajout
       anonyme au milieu des ajouts unitaires et fausserait le comptage.
       L'ajout lui-même reste tracké par ei-cart-popover.js, qui émet un
       `ei_add_to_cart` PAR PRODUIT réellement ajouté : on ne mesure ici que
       l'intention et sa valeur.

       🚨 CAPTURE SUR DOCUMENT, comme l'ajout unitaire ci-dessus — la version
       d'origine de ce bloc posait un écouteur sur chaque bouton. Ça ne part
       JAMAIS : ce bouton est un `button[name="add"]` dans un form `/cart/add`,
       donc ei-cart-popover.js l'intercepte en capture sur document et y appelle
       `stopPropagation()`. L'événement n'atteint pas le bouton. C'est le bug
       exact qui a rendu `action: 'ajout'` muet 34 jours (19-08 → 22-09).
       Ne pas « simplifier » en revenant sur les boutons. */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-ei-cap-add-tout]') : null;
      if (!b) return;
      var porteur = b.closest('[data-ei-cap-bloc]');
      ga4('ei_recette_tout_ajouter', {
        bloc: porteur ? porteur.getAttribute('data-ei-cap-bloc') : 'principal',
        nb_produits: parseInt(b.getAttribute('data-ei-nb'), 10) || 0,
        prix: parseFloat(b.getAttribute('data-ei-total')) || 0
      });
    }, true);

    /* Départ vers une fiche produit (clic sur le nom ou la photo).
       Sans ça, tout un pan de ce que rapporte le bloc reste invisible :
       beaucoup de gens consultent la fiche avant d'ajouter au panier. */
    document.querySelectorAll('[data-ei-cap-shop] a[href*="/products/"]').forEach(function (a) {
      a.addEventListener('click', function () {
        var ligne = a.closest('[data-ei-prod-nom]');
        var porteur = a.closest('[data-ei-cap-bloc]');
        ga4('ei_recette_produit_click', {
          action: 'fiche',
          bloc: porteur ? porteur.getAttribute('data-ei-cap-bloc') : 'principal',
          produit: ligne ? ligne.getAttribute('data-ei-prod-nom') : a.textContent.trim().slice(0, 60),
          prix: ligne ? (parseFloat(ligne.getAttribute('data-ei-prod-prix')) || 0) : 0
        });
      });
    });

    /* Produits proposés dans l'écran de confirmation d'inscription */
    document.querySelectorAll('[data-ei-cap-prod="success"]').forEach(function (a) {
      a.addEventListener('click', function () {
        ga4('ei_recette_produit_click', { action: 'fiche_confirmation' });
      });
    });
  }

  /* ---------- init ---------- */

  function init() {
    repositionner();
    /* avant remonterBlocProduits() : le repli change les hauteurs, on veut
       que le bloc produits se place dans la page déjà compactée. */
    replierIntroduction();
    remplacerVisuelConseils();
    /* après remplacerVisuelConseils() : le visuel porte alors la classe
       .ei-conseils-margot, et remonterBlocProduits() sait le retrouver */
    remonterBlocProduits();
    /* après remonterBlocProduits() : le bloc principal a pris sa place, on
       place ensuite le variante à son étape sans interférer avec la flèche. */
    placerBlocVariante();
    deplacerBlocSocial();
    masquerBlocsVides();
    ingredientsCochables();
    confirmation();
    verrouConsentement();
    sticky();
    tracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
